import {
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider
} from '@material-ui/core';
import React from 'react';
import AllPagesPDFViewer from 'src/components/pdf/all-pages';
import { MobilePDFReader, PDFReader } from 'react-read-pdf';
import samplePDF from './Manual.pdf';


export default function App() {
  return (
    <div>
      {/* <AllPagesPDFViewer pdf={samplePDF} /> */}
      <MobilePDFReader url={samplePDF} />
    </div>

  );
}
